import React from 'react';
import { createRoot } from 'react-dom/client';
import { EstqRouter } from './EstqRouter';

const container = document.getElementById('root');
const root = createRoot(container as Element);

root.render(<EstqRouter />);
